import React, { useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import "./UserAddress.css";
import CreateAddressModal from "./CreateAddressModal";
import { useDispatch, useSelector } from "react-redux";
import { listAddressAction } from "../../../redux/actions/User";

const UserAddress = () => {
  const [ShowModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const addresses = useSelector((state) => state.user.userAddress);
  useEffect(() => {
    if (addresses?.length === 0) {
      dispatch(listAddressAction());
    }
  }, []);

  return (
    <div className="py-5 px-5 my-[30px]">
      <div className="w-full flex justify-between place-items-center">
        <h2 className="text-[25px] font-bold mb-3">Your Available Address.</h2>
        <button
          className="flex justify-between place-items-center gap-2 px-5 my-2 rounded-md mx-2 py-2 bg-color1 border-[1px] text-color2 hover:bg-color2 hover:text-color1 hover:border-[1px]"
          onClick={() => {
            setShowModal(true);
          }}
        >
          Add New
          <AiOutlinePlus />
        </button>
      </div>

      {/* ----- table  */}

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-[100%] my-[50px] max-h-[400px] overflow-y-auto border-[1px] border-shadowColor">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 !bg-color1 address_table">
          <thead className="text-xs text-white uppercase dark:bg-shadowColor">
            <tr>
              <th scope="col" className="px-6 py-3">
                Address Name
              </th>
              <th scope="col" className="px-6 py-3">
                Full Name
              </th>
              <th scope="col" className="px-6 py-3">
                Country
              </th>
              <th scope="col" className="px-6 py-3">
                City
              </th>
              <th scope="col" className="px-6 py-3">
                State
              </th>
              <th scope="col" className="px-6 py-3">
                Postal Code
              </th>
              <th scope="col" className="px-6 py-3">
                Email Address
              </th>
              {/* <th scope="col" className="px-6 py-3">
                Action
              </th> */}
            </tr>
          </thead>
          <tbody>
            {addresses?.map((item, index) => {
              return (
                <tr
                  key={index}
                  className={`!bg-color1  !text-color2 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 border-b-[1px] border-b-redColor`}
                >
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium whitespace-nowrap dark:text-white"
                  >
                    {item?.name || "---"}
                  </th>
                  <td className="px-6 py-4">{item?.FullName}</td>
                  <td className="px-6 py-4">{item?.Country}</td>
                  <td className="px-6 py-4">{item?.City}</td>
                  <td className="px-6 py-4">{item?.State}</td>
                  <td className="px-6 py-4">{item?.ZipCode}</td>
                  <td className="px-6 py-4">{item.email}</td>
                  {/* <td className="flex items-center px-6 py-4">
                    <a
                      href="#"
                      className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                    >
                      Edit
                    </a>
                  </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* ------ modal  */}
      {ShowModal && <CreateAddressModal setHideModal={setShowModal} />}
    </div>
  );
};

export default UserAddress;
